var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgShareDesktop = function SvgShareDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.667 2.75h14.666c1.013 0 1.834.82 1.834 1.833v11c0 1.013-.821 1.834-1.834 1.834h-2.75a.917.917 0 010 1.833H6.417a.917.917 0 010-1.833h-2.75a1.833 1.833 0 01-1.834-1.834v-11c0-1.012.821-1.833 1.834-1.833zm0 1.833v11h14.666v-11H3.667zm8.25 3.667c-3.75 0-5.5 1.604-5.5 6.417 2-3.896 5.5-3.667 5.5-3.667v1.274a.5.5 0 00.813.39l3.287-2.65a.5.5 0 000-.778l-3.287-2.65a.5.5 0 00-.813.39V8.25z"
  })));
};

export default SvgShareDesktop;